'use strict';

document.addEventListener("DOMContentLoaded", function () {
    var logincheck = $('#cart-popup-global').attr("data-login");
    //adding condition for login as getting logincheck variable as string True
    if (logincheck == "True" || logincheck == "true") {
        CheckShoppingCart()
    }
});
function _AntiForgeryToken(id) {
    $.ajax({
        url: "/login/RefreshToken",
        type: "GET",
        dataType: "json",
        beforeSend: function (xhr) {
            xhr.setRequestHeader('Content-Type', 'application/json');
        },
        success: function (data) {
            //console.log(data);
        },
        complete: function (data) {
            //console.log("Hello", data);
            $(id).html(data.responseText);
            // Set our complete callback, 
        },
        error: function (e) {
            //alert("error");
        }
    });
}
function CheckShoppingCart() {
    var getCartItemsAPI = "/api/cart/cartcount";
    fetch(getCartItemsAPI,
        {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                "RequestVerificationToken": $("#checkloginApi [name='__RequestVerificationToken']").val()
            },
        }).then(results => {
            if (!results.ok) {
                console.error(`API request failed with status code: ${response.status}`);
                return;
            }
            return results.text();
        }).then((data) => {
            if (!Number.isNaN(data)) {
                checkIcon(parseInt(data));
            }
        });
    _AntiForgeryToken("#checkloginApi");
}

function checkIcon(data) {
    if (data !== null && !Number.isNaN(data)) {
        document.getElementById("counterCart").dataset.items = data;
        document.querySelector(".cart").classList.add("added");
        document.querySelector(".cart").classList.add("counterLoading");
    }
    else {
        document.querySelector(".cart").classList.remove("added");
        document.querySelector(".cart").classList.remove("counterLoading");
    }
    if (data == 0) {
        document.querySelector(".cart").classList.remove("added");
    }
    setTimeout(function () {
            document.querySelector(".cart").classList.remove("counterLoading");
    }, 1000);
}